<template>
  <!-- Back Button -->
  <div
    class="my-5 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 cursor-pointer transition"
    @click="$router.go(-1)"
  >
    <BackSvg />
  </div>

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-orange-600">
      We're Always Here to Help
    </h1>

    <p class="text-sm text-neutral-500 mt-1">
      Reach out to the appropriate department below and we'll be happy to assist
      you.
    </p>
  </div>

  <!-- Contact Cards -->
  <div class="space-y-4">
    <!-- Customer Service -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <div class="flex items-center justify-between mb-4">
        <h2 class="font-semibold text-neutral-800">Customer Service Hotline</h2>

        <span
          class="text-xs font-medium bg-orange-50 text-orange-600 px-3 py-1 rounded-full"
        >
          24/7 Support
        </span>
      </div>

      <div class="space-y-2 text-sm text-neutral-600">
        <a
          href="tel:+639228221033"
          class="block hover:text-orange-500 transition"
        >
          +63 (922) 822-1033 to 35 (SUN)
        </a>

        <a
          href="tel:+639178518645"
          class="block hover:text-orange-500 transition"
        >
          +63 (917) 851-8645 (GLOBE)
        </a>

        <a
          href="tel:+639985869439"
          class="block hover:text-orange-500 transition"
        >
          +63 (998) 586-9439 (SMART)
        </a>

        <a
          href="tel:+63285280480"
          class="block hover:text-orange-500 transition"
        >
          (02) 8528-0480 (Landline)
        </a>

        <div class="pt-3 border-t border-neutral-100">
          <a
            href="mailto:customerservices@iwc.com.ph"
            class="font-medium text-orange-500 hover:underline"
          >
            customerservices@iwc.com.ph
          </a>
        </div>
      </div>
    </div>

    <!-- Reimbursement -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <h2 class="font-semibold text-neutral-800 mb-3">Reimbursement Claims</h2>

      <a
        href="mailto:reimbursements@iwc.com.ph"
        class="text-sm font-medium text-orange-500 hover:underline"
      >
        reimbursements@iwc.com.ph
      </a>
    </div>

    <!-- Membership -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <h2 class="font-semibold text-neutral-800 mb-3">
        Membership Orientation / IWC Card Assistance
      </h2>

      <a
        href="mailto:salesandclientrelations@iwc.com.ph"
        class="text-sm font-medium text-orange-500 hover:underline"
      >
        salesandclientrelations@iwc.com.ph
      </a>
    </div>

    <!-- Dental -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <h2 class="font-semibold text-neutral-800 mb-3">
        Dental Benefits Assistance
      </h2>

      <div class="flex flex-wrap gap-2 mb-4">
        <span
          class="text-xs bg-neutral-100 text-neutral-600 px-3 py-1 rounded-full"
        >
          Mon - Fri: 8:00 AM - 5:00 PM
        </span>

        <span
          class="text-xs bg-neutral-100 text-neutral-600 px-3 py-1 rounded-full"
        >
          Sat: 9:00 AM - 5:00 PM
        </span>
      </div>

      <div class="space-y-2 text-sm text-neutral-600">
        <a
          href="tel:+639338792346"
          class="block hover:text-orange-500 transition"
        >
          +63 (933) 879-2346 (SUN)
        </a>

        <a
          href="tel:+639178269156"
          class="block hover:text-orange-500 transition"
        >
          +63 (917) 826-9156 (GLOBE)
        </a>

        <a
          href="tel:+639088913655"
          class="block hover:text-orange-500 transition"
        >
          +63 (908) 891-3655 (SMART)
        </a>
      </div>
    </div>

    <!-- Technical Support -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <h2 class="font-semibold text-neutral-800 mb-3">AMAP Support</h2>

      <a
        href="mailto:contact@amap.iwcsrvr.com"
        class="text-sm font-medium text-orange-500 hover:underline"
      >
        contact@amap.iwcsrvr.com
      </a>
    </div>

    <!-- Technical Support -->
    <div
      class="bg-white border-l-4 border-orange-500 border border-neutral-200 rounded-xl p-5 shadow-sm"
    >
      <h2 class="font-semibold text-neutral-800 mb-3">
        Teleconsultation support
      </h2>

      <a
        href="mailto:contact@interactivemedicalfacilities.com"
        class="text-sm font-medium text-orange-500 hover:underline"
      >
        contact@interactivemedicalfacilities.com
      </a>
    </div>
  </div>
</template>

<script>
import BackSvg from "@/components/svgs/BackSvg.vue";

export default {
  name: "ContactUsView",
  components: {
    BackSvg,
  },
};
</script>
